export default __webpack_public_path__ + "static/media/AreYouReady.6165d0cf.svg";